import { Modal } from '../Modal';
import { SchedulesContainer, ScheduleCard, Tag, BadgeRow, InfoRow, ActionButton } from './styled';
import { BsClock, BsSun, BsCalendar3, BsCameraVideoFill, BsMoon } from 'react-icons/bs';
import { FaStethoscope } from 'react-icons/fa';

export function SelectSchedule(props) {
    const { schedulesList, showSchedulesModal, handleCloseModal, handleScheduleSelect } = props;

    return (
        <Modal
            title="Selecione um Agendamento"
            isOpen={showSchedulesModal}
            close={handleCloseModal}
        >
            <SchedulesContainer>
                {schedulesList.map(schedule => {
                    const dateFormatted = schedule?.dt_agenda
                        ? schedule.dt_agenda.split('T')[0].split('-').reverse().join('/')
                        : '—';
                        
                    const period = schedule?.periodo?.toUpperCase() || '—';
                    const PeriodIcon = period === 'MANHÃ' ? BsSun : BsMoon;

                    return (
                        <ScheduleCard key={schedule.cd_it_agenda_central}>
                            <div className="card-header">
                                <span className="date-title">{dateFormatted}</span>
                                <Tag className="teleconsulta-tag">TELECONSULTA</Tag>
                            </div>
                            
                            <div className="service-title">
                                {schedule?.servico}
                            </div>

                            <BadgeRow>
                                <div className="badge">
                                    <BsClock />
                                    <span>{schedule?.hr_agenda || '—'}</span>
                                </div>
                                <div className="badge">
                                    <PeriodIcon />
                                    <span>{period}</span>
                                </div>
                            </BadgeRow>

                            <div className="info-section">
                                <InfoRow>
                                    <FaStethoscope className="icon" />
                                    <span>{schedule?.especialidade || '—'}</span>
                                </InfoRow>
                                <InfoRow>
                                    <BsCalendar3 className="icon" />
                                    <span>{schedule?.local || '—'}</span>
                                </InfoRow>
                                <InfoRow className="online-info">
                                    <BsCameraVideoFill className="icon" />
                                    <span>Atendimento online</span>
                                </InfoRow>
                            </div>

                            <ActionButton onClick={() => handleScheduleSelect(schedule)}>
                                <BsCameraVideoFill />
                                Iniciar Teleconsulta
                            </ActionButton>
                        </ScheduleCard>
                    );
                })}
            </SchedulesContainer>
        </Modal>
    )
}
